module.exports = __webpack_public_path__ + "img/school5.e6dd86aa.png";